const AuthConstants = require('./constants');

const COMPLETION_CLASSIFICATIONS = AuthConstants.authFlow.mfaCompletionClassifications;
const SOURCES = AuthConstants.authFlow.sources;

module.exports = {
    COMPLETION_CLASSIFICATIONS,
    classifyCompletion
};

function classifyCompletion({ signupContext = {}, mfaToken } = {}) {

    const isSignupCompletion = signupContext.mfaPurpose === SOURCES.signupCompletionMfa
        || (!!signupContext.mfaToken && signupContext.mfaToken === mfaToken);

    return isSignupCompletion
        ? COMPLETION_CLASSIFICATIONS.signupCompletion
        : COMPLETION_CLASSIFICATIONS.authenticated;
}
